// Sanitize a phone number string
export const phone = num => (num.split('')[0] === '1' ? num.substring(1) : num)

export default {
  phone,
}
